import { render } from "./accountModifyRole.vue?vue&type=template&id=6cad57fc&scoped=true&ts=true"
import script from "./accountModifyRole.vue?vue&type=script&lang=ts"
export * from "./accountModifyRole.vue?vue&type=script&lang=ts"

import "./accountModifyRole.vue?vue&type=style&index=0&id=6cad57fc&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cad57fc"]])

export default __exports__